// extracted by mini-css-extract-plugin
export default {"flexCenter":"FieldTableHeader_flexCenter__vbJco","textInput":"FieldTableHeader_textInput__5+zxh"};